import React, { useState } from 'react';
import { authService } from '../../services/authService';
import './LoginForm.css';

const LoginForm = ({ onLogin, onSwitchToRegister }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authService.login(email, password);
      onLogin(response.user);
    } catch (err) {
      setError(err.response?.data?.message || 'Ошибка при входе');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-title">Форма входа</h2>

        <form onSubmit={handleSubmit}>
          <div className="login-form-group">
            <label className="login-form-label">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email@example.com"
              className="login-form-input"
              required
            />
          </div>

          <div className="login-form-group">
            <label className="login-form-label">
              Пароль
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="login-form-input"
              required
            />
          </div>

          {error && (
            <div className="login-form-error">{error}</div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="login-form-button"
          >
            {loading ? 'Вход...' : 'Войти'}
          </button>
        </form>

        <div className="login-form-footer">
          <button 
            onClick={() => alert('Восстановление пароля')}
            className="login-form-footer-link"
          >
            Забыли пароль?
          </button>
          <button 
            onClick={onSwitchToRegister}
            className="login-form-footer-link"
          >
            Регистрация
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;